import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import authPages from 'prismic-translates/auth-pages.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([authPages])

type Props = {
  type: string
}

function AuthWaysTitle(props: Props) {
  switch (props.type) {
    case 'invited_by': {
      return (
        <h6 className={classes.dialogCaption}>
          <b>{t('register')}</b> {t('now_to_activate')}
          <br />
          {t('your')} <b>{t('sweepstakes_coins')}</b>
        </h6>
      )
    }
    default: {
      return (
        <h6 className={classes.dialogCaption}>
          {t('get_your')} <b>{t('free_coins')}</b>
          <br />
          {t('and')} <b>{t('start_winning')}</b> {t('now')}
        </h6>
      )
    }
  }
}

export default AuthWaysTitle
